import React, { Component } from 'react'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import PrepaymentUI from './PrepaymentUI.js'
import CacheManager from '../../../../cache/CacheManager.js'
import CacheKeys from '../../../../cache/CacheKeys.js'

class PrepaymentSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      prepaymentInternalSubmitted: false,
      loanClosureNoteSubmitted: false,
      prepaymentExternalSubmitted: false,
      closureSubmitted: false,
      waivedUpdated: false,
      //
      prepaymentInitiateSubmitted: false,
      prepaymentErrorList: null,
      prepaymentSuccessMsg: null,
      //
      prepaymentRequestMode: false,
      //
      year: '',
      month: '',
    }
  }

  render() {
    let monthList = [
      { value: '01', label: 'Jan' },
      { value: '02', label: 'Feb' },
      { value: '03', label: 'Mar' },
      { value: '04', label: 'Apr' },
      { value: '05', label: 'May' },
      { value: '06', label: 'Jun' },
      { value: '07', label: 'Jul' },
      { value: '08', label: 'Aug' },
      { value: '09', label: 'Sep' },
      { value: '10', label: 'Oct' },
      { value: '11', label: 'Nov' },
      { value: '12', label: 'Dec' },
    ]
    return (
      <PrepaymentUI
        context={this.props.context}
        errorList={this.props.errorList}
        loan={this.props.loan}
        account={this.props.account}
        prepayment={this.props.prepayment}
        repaymentGoodStanding={this.props.repaymentGoodStanding}
        onRefreshClick={this.props.onRefreshClick}
        //
        onPrepaymentRequestInternal={this.onPrepaymentRequestInternal}
        onLoanClosureNoteRequested={this.onLoanClosureNoteRequested}
        onPrepaymentRequestExternal={this.onPrepaymentRequestExternal}
        onClosureLetter={this.onClosureLetter}
        prepaymentInternalSubmitted={this.state.prepaymentInternalSubmitted}
        loanClosureNoteSubmitted={this.state.loanClosureNoteSubmitted}
        prepaymentExternalSubmitted={this.state.prepaymentExternalSubmitted}
        closureSubmitted={this.state.closureSubmitted}
        //
        waivedUpdated={this.state.waivedUpdated}
        onWaivedUpdateClick={this.onWaivedUpdateClick}
        onWaivedCancelClick={() => { this.setState({ waivedUpdated: false }) }}
        //
        onPrepaymentInitiate={this.onPrepaymentInitiate}
        prepaymentInitiateSubmitted={this.state.prepaymentInitiateSubmitted}
        prepaymentSuccessMsg={this.state.prepaymentSuccessMsg}
        prepaymentErrorList={this.state.prepaymentErrorList}
        //Prepayment Request Send Modal
        onPrepaymentRequestClick={() => { this.setState({ prepaymentRequestMode: true }) }}
        prepaymentRequestMode={this.state.prepaymentRequestMode}
        onPrepaymentRequestCancel={() => { this.setState({ prepaymentRequestMode: false }) }}
        //
        monthList={monthList}
        yearList={this.state.yearList}
        year={this.state.year}
        month={this.state.month}
        onYearChange={this.onYearChange}
        onMonthChange={this.onMonthChange}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getYears(context)
  }

  onYearChange = (option) => {
    this.setState({ year: option.value })
  }

  onMonthChange = (option) => {
    this.setState({ month: option.value })
  }

  getYears(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/years`,
      cacheKey: CacheKeys.Years(),
      callback: this.getYearsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getYearsCallback = (response) => {
    let yearList = response.yearList.map((years) => {
      return { value: years, label: years }
    })
    this.setState({ errorList: response.errorList, yearList: yearList })
  }

  // onPrepaymentRequestInternal = () => {
  //   let context = this.props.context
  //   this.setState({ prepaymentInternalSubmitted: true })
  //   RestApiUtils.post(context, `/api/su/loans/${this.props.loan.loanId}/prepayments/request?external=false`,
  //     this.onPrepaymentRequestInternalCallback, {})
  // }

  // onPrepaymentRequestInternalCallback = (response) => {
  //   this.setState({ prepaymentInternalSubmitted: false })

  //   if (response.errorList.length === 0) {
  //     const link = document.createElement('a')
  //     link.href = response.signedUrl.signedUrl
  //     document.body.appendChild(link)
  //     link.click()
  //     document.body.removeChild(link)
  //   }
  // }

  onLoanClosureNoteRequested = () => {
    let yearMonth = (this.state.year === '' || this.state.month === '') ? '' : `${this.state.year}-${this.state.month}`
    let context = this.props.context
    this.setState({ loanClosureNoteSubmitted: true })
    RestApiUtils.post(context, `/api/su/loans/${this.props.loan.loanId}/prepayments/request?external=false&yearMonth=${yearMonth}`,
      this.onLoanClosureNoteRequestedCallback, {})
  }

  onLoanClosureNoteRequestedCallback = (response) => {
    this.setState({ loanClosureNoteSubmitted: false })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onPrepaymentRequestExternal = () => {
    let context = this.props.context
    this.setState({ prepaymentExternalSubmitted: true })
    RestApiUtils.post(context, `/api/su/loans/${this.props.loan.loanId}/prepayments/request?external=true`,
      this.onPrepaymentRequestExternalCallback, {})
  }

  onPrepaymentRequestExternalCallback = (response) => {
    this.setState({ prepaymentExternalSubmitted: false })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onClosureLetter = () => {
    let context = this.props.context
    this.setState({ closureSubmitted: true })
    RestApiUtils.post(context, `/api/su/loans/${this.props.loan.loanId}/loanClosureLetter`,
      this.onClosureLetterCallback, {})
  }

  onClosureLetterCallback = (response) => {
    this.setState({ closureSubmitted: false })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onPrepaymentInitiate = () => {
    let context = this.props.context
    this.setState({ prepaymentInitiateSubmitted: true })
    RestApiUtils.post(context, `/api/su/loans/${this.props.loan.loanId}/prepayments`,
      this.onPrepaymentInitiateCallback, {})
  }

  onPrepaymentInitiateCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      prepaymentSuccessMsg: response.success,
      prepaymentErrorList: errorList,
      prepaymentInitiateSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          prepaymentSuccessMsg: null
        })
        this.props.onRefreshClick()
      }, 2000)
    }
  }

  onWaivedUpdateClick = () => {
    this.setState({ waivedUpdated: true })
  }
}

export default PrepaymentSF
